import { Therapy, TherapyType } from '@alberta/konexi-shared';
import { Component, Input, OnInit } from '@angular/core';
import { AuditDto } from 'src/app/shared/models/swodoc/audit-dto.model';
import { AuditNodeDto } from 'src/app/shared/models/swodoc/audit-node-dto.model';

import { CrossTherapyArticleLineViewModel } from './../../../../../../business/cross-therapy/cross-therapy-article-line-view-model';
import { GroupArticleLinesService } from './../../../group-article-lines.service';

export interface SummaryArticleLine {
  articleId: string;
  articleName: string;
  therapyId: Therapy;
  therapyTypeId: TherapyType;
  articleDescription: string;
  articleCustomerNumber: string;
  totalAmount: number;
  articles: {
    resmedTenant: string;
    batchNumber: string;
    serialNumber: string;
    storageLocation: string;
    operatingHours: number;
    unit: string;
    quantity: number;
    packagingUnitQuantity: number;
    totalPrice?: string;
    ordered?: boolean;
  }[];
}
@Component({
  selector: 'swodoc-node-cross-therapy-summary',
  templateUrl: './swodoc-node-cross-therapy-summary.html',
  styleUrls: ['./swodoc-node-cross-therapy-summary.scss'],
  providers: [GroupArticleLinesService],
})
export class SwodocNodeCrossTherapySummary implements OnInit {
  @Input() audit: AuditDto;

  public auditNode: AuditNodeDto;
  public articleLines: SummaryArticleLine[] = [];

  constructor(private _groupArticleService: GroupArticleLinesService) {}
  async ngOnInit() {
    this.findNodeByTypeId();
    const crossTherapyArticleLines = this.auditNode?.responses[0]?.value;
    if (!crossTherapyArticleLines || !Array.isArray(crossTherapyArticleLines)) {
      return;
    }
    this.articleLines = this._groupArticleService.groupArticles(
      crossTherapyArticleLines as CrossTherapyArticleLineViewModel[]
    );
  }

  private findNodeByTypeId() {
    this.audit.auditNodes.forEach(auditNode => {
      auditNode.children.forEach(child => {
        if (child.nodeType_Id === 'crossTherapyArticleData') {
          this.auditNode = child;
        }
      });
    });
  }
}
